// eslint-disable-next-line @typescript-eslint/no-unused-vars
const noop = ( ..._args: any[] ): void => {};

export default noop;
